<template>
    <v-app id="valesco">
        <!--PAGE HEADER-->
        <router-view name="header" @clicked="toggleDrawer()" />
        <v-main id="page-body">
            <v-container id="main-container">
                <router-view name="default" :sideBarVisible=showSideBar></router-view>
            </v-container>
        </v-main>

        <!-- PAGE FOOTER -->
        <router-view name="footer" />
    </v-app>
</template>
<script>
export default {
    data() {
        return {
            showSideBar: true,
            dialog: false,
            drawer: null,
        };
    },
    props: {
        source: String
    },
    methods: {
        toggleDrawer(value) {
            this.showSideBar = !this.showSideBar;
        }
    }
}
</script>
<style>
#page-body {
    /* padding: 0px 0px 0px 256px !important; */
    margin-top: 48px;
    /* border: 1px solid red; */
    height: calc(100vh - 48px - 72px);
    max-height: calc(100vh - 48px - 72px);
    /* background-color: darkgreen; */
    overflow-y: scroll;
}

#main-container {
    /*background-color: red;*/
    padding: 0px;
}

.container {
    max-width: 3000px !important;
}

#banner {
    position: fixed;
    padding: 0;
    top: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 2000;
}

#banner div {
    margin-top: -2px;
    margin-left: 5%;
    /*margin-right: auto;*/
    max-width: 300px;
    overflow: hidden;
}
</style>
